"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Menu {
  constructor() {
    _defineProperty(this, "menuItems", void 0);
    _defineProperty(this, "getMenuItem", (id, menuItemChildren) => {
      const self = this;
      let menuItemList = this.menuItems;
      if (typeof menuItemChildren !== 'undefined') {
        menuItemList = menuItemChildren;
      }
      if (typeof menuItemList === 'undefined') {
        return null;
      }
      let menuItem = null;
      for (let i = 0; i < menuItemList.length; i += 1) {
        if (menuItemList[i].id === id) {
          menuItem = menuItemList[i];
          break;
        }
        if (typeof menuItemList[i].children !== 'undefined') {
          menuItem = self.getMenuItem(id, menuItemList[i].children);
          if (menuItem != null) {
            break;
          }
        }
      }
      return menuItem;
    });
    _defineProperty(this, "getChildren", (name, menuItemChildren, recursion) => {
      const self = this;
      let items = [];
      let menuItemList = menuItemChildren;
      if (!recursion) {
        menuItemList = this.menuItems;
      }
      if (typeof menuItemList === 'undefined') {
        return items;
      }
      // if (typeof menuItemList.length === 'undefined') {
      //   return getChildren(name, menuItemList.children);
      // }

      if (typeof menuItemList !== 'undefined') {
        for (let i = 0; i < menuItemList.length; i += 1) {
          if (menuItemList[i].name === name) {
            if (typeof menuItemList[i].children !== 'undefined') {
              return menuItemList[i].children;
            }
          }
        }
        for (let i = 0; i < menuItemList.length; i += 1) {
          if (typeof menuItemList[i].children !== 'undefined') {
            const tempItems = self.getChildren(name, menuItemList[i].children, true);
            items = items.concat(tempItems);
          }
        }
      }
      return items;
    });
    _defineProperty(this, "getMenuItemsWithComponents", (menuItemChildren, recursion) => {
      const self = this;
      let items = [];
      let menuItemList = menuItemChildren;
      if (!recursion) {
        menuItemList = this.menuItems;
      }
      if (typeof menuItemList !== 'undefined') {
        for (let i = 0; i < menuItemList.length; i += 1) {
          if (typeof menuItemList[i].path !== 'undefined' && menuItemList[i].path !== '' && menuItemList[i].path != null && typeof menuItemList[i].component !== 'undefined' && menuItemList[i].component != null && menuItemList[i].component !== '') {
            items.push(menuItemList[i]);
          }
          if (typeof menuItemList[i].children !== 'undefined') {
            items = items.concat(self.getMenuItemsWithComponents(menuItemList[i].children, true));
          }
        }
      }
      return items;
    });
    _defineProperty(this, "getMenuItemList", (menuItemChildren, recursion) => {
      const self = this;
      let items = [];
      let menuItemList = menuItemChildren;
      if (!recursion) {
        menuItemList = this.menuItems;
      }
      if (typeof menuItemList !== 'undefined') {
        for (let i = 0; i < menuItemList.length; i += 1) {
          items.push(menuItemList[i]);
          if (typeof menuItemList[i].children !== 'undefined') {
            items = items.concat(self.getMenuItemList(menuItemList[i].children, true));
          }
        }
      }
      return items;
    });
  }
  static from(json) {
    const obj = Object.assign(new Menu(), json);
    return obj;
  }
  getMainMenuLinks() {
    return this.getChildren('Main-Menu-Links');
  }
  getMenuPath(id, stopAtMenuItemName) {
    const menuItems = this.getMenuItemList();
    const path = [];
    let currentMenuItem = menuItems.find(menuItem => menuItem.id === id);
    let counter = 0;
    const max = 100;
    const stopName = stopAtMenuItemName || 'Main-Menu-Links';
    while (currentMenuItem && counter < max) {
      path.push(currentMenuItem);
      const currentMenuItemSafe = {
        ...currentMenuItem
      };
      currentMenuItem = menuItems.find(menuItem => menuItem.id === currentMenuItemSafe.parentId && menuItem.name !== stopName);
      counter++;
    }
    return path.reverse();
  }
}
exports.default = Menu;
//# sourceMappingURL=Menu.js.map